import { useTranslation } from 'react-i18next';

import { Grid, Paper } from '@mui/material';

import { Table } from '../../components/table/table';
import { HeadCell, Row, RowCell } from '../../components/table/types';

import { RouterPaths } from '../../router/paths';
import { useNavigate } from 'react-router-dom';
import { useGetProviderFeesQuery, useGetProvidersQuery } from '../../api/controllers/providers';
import { permissionsCheck } from '../../utils/permission';

export const Provider = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const hasPermissionToViewProviderFees = permissionsCheck(['READ_EXCHANGE_PROVIDER_FEES']);

  // api
  const { data: feeList } = useGetProvidersQuery({});

  // table cells and rows
  const headCells: HeadCell[] = [{ id: '1', label: t('providers-fee.head-cells.provider') }];

  const rows: Row[] | undefined = feeList?.providers.map((provider) => {
    const cells: RowCell[] = [{ name: 'provider', value: provider }];

    return {
      cells,
      onClick: () =>
        hasPermissionToViewProviderFees && navigate(`${RouterPaths.ProviderFees}/${provider}/fees`),
      hover: hasPermissionToViewProviderFees,
      sx: { cursor: 'pointer' },
    };
  });

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Table headCells={headCells} rows={rows} />
        </Paper>
      </Grid>
    </>
  );
};
